import C from "../../../banner/ui/components/index.js";
import { Footer as R } from "../../../footer/ui/index.js";
import { MetadataOptions as I } from "../../../meta_data/utilities/types/index.js";
import { useMeta as b } from "../../../meta_data/utilities/index.js";
import B from "./index5.js";
import { ExternalResourcePositions as n } from "../types/index2.js";
import { ExternalResourcePositions as bt } from "../types/index2.js";
import { defineComponent as h, defineAsyncComponent as F, toRefs as O, computed as e, watch as r } from "vue";
import { initializeErrorListeners as T } from "@ado/error-logger";
import { getConfig as w } from "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import { getCsr as A } from "../../../shared/data/csr/state/index2.js";
import { getLayout as i, setFooterStyle as D, setBannerStyle as v } from "../../../shared/data/layout/state/index.js";
import { BannerStyle as M } from "../../../shared/data/layout/state/index2.js";
import { FooterStyle as k } from "../../../shared/data/layout/state/index3.js";
import { getLocation as z } from "../../../shared/data/location/state/index.js";
import { getNavigation as H } from "../../../shared/data/navigation/state/index2.js";
import { allExperimentsHaveInitialized as L } from "@ado/experiment-library";
import "../../../search/state/index2.js";
import { getUser as N } from "../../../shared/data/user/state/index2.js";
import "@ado/acs-standard-library";
import { loadStoreData as P } from "../utilities/index.js";
import { getCache as W } from "@ado/client-side-caching";
import j from "../../../expired_session/ui/components/index.js";
import { initializeTracking as _ } from "@ado/tracking-library";
import { loadBaseApplicationTranslations as q } from "../../../shared/libraries/local-translations/index.js";
import { getAffiliateClass as U } from "../utilities/index2.js";
const Ct = h({
  name: "BaseApplication",
  components: {
    Footer: R,
    ExternalResources: B,
    Banner: C,
    SignIn: F(
      () => import("../../../sign_in/ui/components/index.js")
    ),
    ExpiredSessionDialog: j
  },
  props: {
    externalResources: {
      type: Array,
      default: () => []
    },
    metadataOptions: {
      type: Object,
      default: () => I.Default()
    },
    disableSendingSignInRequestsToOtherHosts: {
      type: Boolean,
      default: !1
    },
    footerEnabled: {
      type: Boolean,
      default: !0
    },
    footerStyle: {
      type: String,
      default: k.Normal
    },
    bannerStyle: {
      type: String,
      default: M.Normal
    },
    trackingExecutionContext: {
      type: Object,
      default: () => ({})
    }
  },
  setup(o) {
    setTimeout(
      () => W().removeExpiredItems(),
      1e4
    ), T(), P();
    const { metadataOptions: s } = O(o);
    b(s);
    const m = e(() => w().values), l = z(), p = A(), f = N(), c = e(() => i().showSignInDialog);
    r(
      () => o.footerStyle,
      (t) => {
        D(t);
      },
      { immediate: !0 }
    ), r(
      () => o.bannerStyle,
      (t) => {
        v(t);
      },
      { immediate: !0 }
    );
    const u = e(() => i().bannerStyle), d = e(() => i().footerStyle), g = e(
      () => H().menuCategories
    ), a = (t) => o.externalResources.filter((E) => E.position === t), y = e(() => a(n.Footer)), S = e(() => a(n.Header));
    r(
      () => o.trackingExecutionContext,
      async (t) => {
        await L(), await _(t);
      },
      { immediate: !0 }
    ), q();
    const x = U();
    return {
      config: m,
      location: l,
      csr: p,
      user: f,
      banner: u,
      menuCategories: g,
      footer: d,
      footerExternalResources: y,
      headerExternalResources: S,
      showDialog: c,
      affiliateClass: x
    };
  }
});
export {
  bt as ExternalResourcePositions,
  Ct as default
};
//# sourceMappingURL=index2.js.map
